import { create } from "zustand";
import { BackgroundGenerationDataProps } from "../types";
import { defaultRadioOption } from "../../asset-generation/components/ExploreOptions/constant";

const defaultState: Omit<
  BackgroundGenerationDataProps,
  | "updateBackgroundField"
  | "updateBackgroundConfig"
  | "updateBackgroundInputs"
  | "updateBackgroundReview"
  | "resetBackgroundGenerationStore"
  | "hasBackgroundGenerationProjectFormChanged"
  | "resetAll"
> = {
  projectName: "",
  projectId: "",
  imageDimensions: "",
  noOfImages: "1",
  isSaveProjects: false,
  channel: defaultRadioOption,
  version: 0,
  brandId: "",
  backgroundInputs: {
    imageDescription: "",
  },
  backgroundReview: {
    imageUrls: [],
    imageRaiStatus: null,
    modelOutputs: null,
    cachedOutputRaiResponse: null,
    brandKb: "",
    channelKb: "",
  },
};

export const useBackgroundGenerationStore = create<BackgroundGenerationDataProps>()((set, get) => ({
  ...defaultState,

  updateBackgroundField: (key, value) =>
    set((state) => ({
      ...state,
      [key]: value,
    })),

  updateBackgroundConfig: (data) =>
    set((state) => ({
      ...state,
      ...data,
    })),

  updateBackgroundInputs: (data) =>
    set((state) => ({
      ...state,
      backgroundInputs: {
        ...state.backgroundInputs,
        ...data,
      },
    })),

  updateBackgroundReview: (data) =>
    set((state) => ({
      ...state,
      backgroundReview: {
        ...state.backgroundReview,
        ...data,
      },
    })),

  hasBackgroundGenerationProjectFormChanged: (data) => {
    const prev = get();
    const { projectName, imageDimensions, noOfImages, channel } = data;
    return (
      prev.projectName !== projectName ||
      prev.imageDimensions !== imageDimensions ||
      prev.channel?.id !== channel?.id ||
      prev.noOfImages !== noOfImages
    );
  },

  resetBackgroundGenerationStore: () => set(defaultState),
  resetAll: () => set(defaultState),
}));
